import React, { useMemo } from 'react';
import { DataGrid } from 'ui-toolkit';
import { IBootstrapTableColumnProps } from 'react-bootstrap-table-next';
import { IVendorOrderData } from '../../types/vendorDashboard/IVendorOrders';
import { OrdersTableFormatters } from './OrdersTableFormatters';

interface IOrdersTableProps {
  orders: IVendorOrderData[];
  loading: boolean;
}

export const OrdersTable: React.FC<IOrdersTableProps> = ({ orders, loading }) => {
  const columns: IBootstrapTableColumnProps<IVendorOrderData>[] = useMemo(
    () => [
      {
        dataField: 'fileNumber',
        formatter: OrdersTableFormatters.fileNumberFormatter,
        text: 'ID',
      },
      {
        dataField: 'borrowers',
        text: 'Borrower(s)',
      },
      {
        dataField: 'address',
        formatter: OrdersTableFormatters.addressFormatter,
        text: 'Location',
      },
      {
        dataField: 'timeEnteredQueue',
        formatter: OrdersTableFormatters.timeEnteredQueueFormatter,
        text: 'In Queue',
      },
      {
        dataField: 'status',
        formatter: OrdersTableFormatters.statusFormatter,
        text: 'Status',
      },
    ],
    []
  );
  return <DataGrid columns={columns} keyField={'titleSearchId'} data={orders || []} loading={loading} />;
};
